export enum AuthenticateParams {
  ACCESS_TOKEN = 'accessToken',
  USER_SUBDOMAIN = 'userSubdomain',
  ORG_ID = 'orgId',
  TEAM_ID = 'teamId',
  ACTIVE_PROFILE_ID = 'activeProfileId',
  ACTIVE_PROFILE_TYPE = 'activeProfileType'
}

export enum ActiveProfileType {
  ATHLETE = 'athlete',
  COACH = 'coach'
}
